module.exports = __webpack_public_path__ + "media/images/default/pages/about/4-37a82072db7171b458d63f01c265d065.jpg";